import { FunctionComponent, ReactNode } from 'react'
import styled from 'styled-components'

const StyledTileRightHalf = styled.div`
  display: grid;
  justify-content: flex-end;
  align-content: center;
`

const StyledTileRightHalfContent = styled.div`
  display: inline-block;
  min-width: 34px;
  text-align: center;
`

const TileRightHalf: FunctionComponent<{ children?: ReactNode }> = ({
  children,
}) => {
  return (
    <StyledTileRightHalf>
      <StyledTileRightHalfContent>{children}</StyledTileRightHalfContent>
    </StyledTileRightHalf>
  )
}

export default TileRightHalf
